import { z } from "zod";

export const nameSchema = z.string().trim().min(3, "Name Required And Must Be At Least 3 Characters");
